import { render, staticRenderFns } from "./CreateEmailConfig.vue?vue&type=template&id=1d2baae8&"
import script from "./CreateEmailConfig.vue?vue&type=script&lang=ts&"
export * from "./CreateEmailConfig.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEmailConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports